/**
 * Gemeinsamer Auswahl-Optionen-Editor. Ursprünglich inline im Listen-Spalten-
 * Dialog (`ColumnDialog`); herausgezogen, damit die Datei-Spalten in „Meine
 * Dateien" (`FileColumnDialog`) dasselbe Menü 1:1 wiederverwenden statt es zu
 * kopieren (Nutzer-Anforderung 2026-08-26: „Spaltenmenüs von Listen können wir
 * hier 1:1 recyceln und verdrahten"). Rein kontrolliert — der Aufrufer hält den
 * State und baut daraus seine `config`.
 */

import type { Dispatch, SetStateAction } from "react";

export interface SelectOpt {
  value: string;
  label: string;
  color?: string;
}

export const SelectConfigEditor = ({
  options,
  setOptions,
  selectDefault,
  setSelectDefault,
  multiple,
  setMultiple,
}: {
  options: SelectOpt[];
  setOptions: Dispatch<SetStateAction<SelectOpt[]>>;
  selectDefault: string;
  setSelectDefault: Dispatch<SetStateAction<string>>;
  multiple: boolean;
  setMultiple: Dispatch<SetStateAction<boolean>>;
}) => {
  const updateOption = (i: number, patch: Partial<SelectOpt>) =>
    setOptions((os) => os.map((o, j) => (j === i ? { ...o, ...patch } : o)));

  return (
    <div className="ryfe-coldlg__cfg">
      <span className="ryfe-elmenu__head">OPTIONEN</span>
      {options.map((o, i) => (
        <div key={i} className="ryfe-coldlg__opt">
          <input
            className="ryfe-field"
            placeholder="Wert"
            value={o.value}
            onChange={(e) =>
              // Kein separates Label-Feld: das Label spiegelt den Wert.
              updateOption(i, { value: e.target.value, label: e.target.value })
            }
          />
          <input
            type="color"
            aria-label="Farbe"
            value={o.color || "#cccccc"}
            onChange={(e) => updateOption(i, { color: e.target.value })}
          />
          <button
            type="button"
            className="ryfe-btn ryfe-btn--ghost"
            aria-label="Option entfernen"
            onClick={() => setOptions((os) => os.filter((_, j) => j !== i))}
          >
            ✕
          </button>
        </div>
      ))}
      <button
        type="button"
        className="ryfe-btn ryfe-btn--ghost"
        onClick={() => setOptions((os) => [...os, { value: "", label: "" }])}
      >
        + Option
      </button>
      {options.length > 0 && (
        <label className="ryfe-field-label">
          Standard
          <select
            className="ryfe-field"
            value={selectDefault}
            onChange={(e) => setSelectDefault(e.target.value)}
          >
            <option value="">—</option>
            {options
              .filter((o) => o.value.trim() !== "")
              .map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label || o.value}
                </option>
              ))}
          </select>
        </label>
      )}
      <label className="ryfe-check">
        <input
          type="checkbox"
          checked={multiple}
          onChange={(e) => setMultiple(e.target.checked)}
        />
        Mehrfachauswahl
      </label>
    </div>
  );
};
